module.exports = __webpack_public_path__ + "img/logo-rgb-autralis.8fdff71e.png";